import { render, staticRenderFns } from "./bachlist.vue?vue&type=template&id=3a1da90e&scoped=true&"
import script from "./bachlist.vue?vue&type=script&lang=js&"
export * from "./bachlist.vue?vue&type=script&lang=js&"
import style0 from "./bachlist.vue?vue&type=style&index=0&id=3a1da90e&lang=less&scoped=true&"
import style1 from "./bachlist.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1da90e",
  null
  
)

export default component.exports